import { RemoveMealFromSlotRequest } from "@/clients/models/RemoveMealFromSlotRequest";
import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useRemoveMealFromSlot = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.PLAN_REMOVE_MEAL_FROM_SLOT],
    mutationFn: async (requestBody: RemoveMealFromSlotRequest) => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await PlansService.removeMealFromSlotApiV1PlansMealDelete(
        user.id,
        requestBody,
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.PLAN] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CALORIE_BUDGET] });
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.includes(QueryKeys.BALANCE_CALORIES) ||
          query.queryKey.includes(QueryKeys.BALANCE_PROTEIN),
      });
    },
  });

  return {
    removeMealFromSlot: mutate,
    removeMealFromSlotAsync: mutateAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
